<div class="grid">
  <div class="col-12 md:col-6 lg:col-6">
    <button type="button" pButton icon="fa fa-plus" (click)="crearCanal()" *ngIf="menu.agregar"
            label="{{ 'BTN_AGREGAR' | translate}}"></button>
  </div>
  <div class="col-12 md:col-6 lg:col-6">
    <input #gb type="text"  pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
          (input)="dt.filterGlobal($event.target.value, 'contains')">
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <p-table [columns]="columnas" [loading]="cargaNiveles" #dt
              [value]="niveles" selectionMode="single" dataKey="idRiesgosSarlaftniveles"
              [paginator]="true" [rows]="10"  paginatorPosition="bottom">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [pSelectableRow]="row">
          <td class="text-center p-va-middle" >{{row.codigo}}</td>
          <td class="text-center p-va-middle" >{{row.nombre}}</td>
          <td class="text-center p-va-middle" >{{row.nombreTipoProcesoCredito}}</td>
          <td class="text-center p-va-middle" >{{row.rangoMinimo}}</td>
          <td class="text-center p-va-middle" >{{row.rangoMaximo}}</td>
          <td class="text-center p-va-middle" >{{row.descripcion}}</td>
          <td class="text-center p-va-middle" >{{row.nombreDecisionProcesoSarlaft}}</td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                      title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="menu.editar"
                      (click)="editarCanal(row)"></button>
                      <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                              title="{{'BTN_INHABILITAR' | translate}}" pButton *ngIf="menu.editar"
                              (click)="inhabilitarCanal(row)"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" class="text-center">
            {{ 'MSG_NOHAYREGISTROS' | translate}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

